export const apiBaseUrl =  process.env.REACT_APP_ENV === 'dev' ? process.env.REACT_APP_API_BASE_URL_DEV  : process.env.REACT_APP_API_BASE_URL;
export const apiVersionPrefix = process.env.REACT_APP_API_VERSION;

